import { Button as BraidButton } from 'braid-design-system';
import type React from 'react';
import type { MouseEventHandler, MouseEvent } from 'react';

import { useTracking } from 'src/shared/hooks';

type ButtonProps = React.ComponentProps<typeof BraidButton> & {
  tracking: string;
  component?: typeof BraidButton;
  onClick?: MouseEventHandler<HTMLButtonElement>;
};

export const ButtonTracking = ({
  tracking,
  children,
  onClick,
  ...restProps
}: ButtonProps) => {
  const { trackEvent } = useTracking();

  const clickHandler = (event: MouseEvent<HTMLButtonElement>) => {
    trackEvent(tracking);
    if (onClick) {
      onClick(event);
    }
  };

  const combinedProps = {
    ...restProps,
  };

  return (
    <BraidButton {...combinedProps} onClick={clickHandler}>
      {children}
    </BraidButton>
  );
};
